// extracted by mini-css-extract-plugin
module.exports = {"buttons":"AddAccount_buttons__3bbMl","customerChange":"AddAccount_customerChange__36Ct9","newCustomer":"AddAccount_newCustomer__25Qyl"};